export default "__VITE_ASSET__BMTNwzWM__"